import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import swal from 'sweetalert';
import { useStoreState } from 'easy-peasy';

import { toast } from 'react-toastify';
import client from '../../../utils/apolloClient';

const deletePlaceMutation = gql`
  mutation delete_place_claimant($input: NavigatePlaceClaimantInput) {
    delete_place_claimant(input: $input) {
      claimant_id
      error {
        description
      }
    }
  }
`;

const DeletePlaceMutation = ({ claimantId, onCompleted }) => {
  const { userId } = useStoreState(state => state.auth);
  return (
    <Mutation
      client={client.clientPrivate}
      mutation={deletePlaceMutation}
      variables={{
        input: {
          user_id: userId,
          claimant_id: claimantId,
        },
      }}
      onCompleted={({ delete_place_claimant }) => {
        if (delete_place_claimant.error !== null) {
          delete_place_claimant.error.map(item =>
            toast.error(item.description),
          );
        } else {
          onCompleted();
        }
      }}
    >
      {delete_place_claimant => (
        <a
          onClick={() => {
            swal('Are you sure you want to do delete this place?', {
              buttons: ['Cancel', true],
            }).then(willDelete => {
              if (willDelete) {
                delete_place_claimant();
              }
            });
          }}
        >
          <span>
            <i className="fas fa-trash has-text-grey" />
          </span>
        </a>
      )}
    </Mutation>
  );
};

export default DeletePlaceMutation;
